<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import { sgettext } from '../../i18n.js';
  import { elementsUsedInActivity } from '../Workspaces/workspacesStore.js';
  import DataTable from '../DataGrid/DataTable.svelte';
  import { onMount } from 'svelte';
  import { get } from '../../utils.js';
  let currentPage = 1;
  let rows = [];
  let total = 0;
  let loading = true;
  let perPage = 10;

  export let elementId = 0 ;
  export let activityVersionId = 0;

  let dataUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/get_elements_used_in_activity/?element_id=${elementId}&activity_version=${activityVersionId}`;

  let columns = {
      role_name: {
          label: sgettext('$$ROLE$$')
      },
      sequence_name: {
          label: sgettext('$$SEQUENCE$$')
      },
      step: {
          label: sgettext('$$STEP$$')
      }
  };

  onMount(async () => {
    await fetchResults();
  });

  async function changePage(params) {
      currentPage = params.page;
      await fetchResults();
  }

  async function fetchResults() {
      var url = `${dataUrl}&limit=${perPage}&offset=${(currentPage - 1)*perPage}&page=${currentPage}`;
      const resp = await get(url);
      const re = await resp.json();
      try {
          total = re.count;
          elementsUsedInActivity.set(re);
          loading = false;
      } catch (err) {
          console.error(err);
          total = 0;
          elementsUsedInActivity.set([]);
      } finally {
          loading = false;
      } 
  }
</script>

<style>
    .spinnerDiv{
        height:140px;;
        padding-top: 40px;
        padding-left :190px;
    }
    .detail{
        cursor: pointer;
    }
</style>

 <div class="detail">
      {#if loading}
        <div class="spinnerDiv">
            <i class="fas fa-spinner fa-pulse"></i>
        </div>
      {:else}
        <DataTable
            small={true}
            hover={true}
            showFooter={total > perPage}
            {columns}
            rows={$elementsUsedInActivity}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            changePage={changePage}
            footerColSpan={3}
        />
      {/if}
  </div>
